module.exports = __webpack_public_path__ + "static/img/vf_home_v3.c5fe58f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_grande/vf_home_v3.jpg
// module id = WtxK
// module chunks = 1